module.exports = __webpack_public_path__ + "img/manormatters.468d7b03.jpg";